module.exports = __webpack_public_path__ + "img/eld.dc6541c5.svg";